// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Namespace$Showside from "../types/Namespace.bs.js";
function getElementNamespace(el) {
  var namespace = el.getAttribute("data-namespace");
  if (namespace == null) {
    return Namespace$Showside.empty;
  } else {
    return Namespace$Showside.fromString(namespace);
  }
}
function getElementByNamespace(elements, namespace) {
  var namespace$1 = Belt_Option.getWithDefault(namespace, Namespace$Showside.empty);
  return Belt_Array.keep(Belt_Option.getWithDefault(Belt_Option.map(elements, Js_dict.values), []), function (element) {
    return Caml_obj.equal(getElementNamespace(element), namespace$1);
  });
}
function getInlineElementByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsInline, namespace);
}
function getBottombarElementByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElements, namespace);
}
function getLauncherElementByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsLauncher, namespace);
}
function getSectionElementByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsSection, namespace);
}
function getPDPElementByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsPDP, namespace);
}
function countInlineElementsByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsInline, namespace).length;
}
function countBottombarElementsByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElements, namespace).length;
}
function countLauncherElementsByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsLauncher, namespace).length;
}
function countSectionElementsByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsSection, namespace).length;
}
function countPDPElementsByNamespace(namespace) {
  return getElementByNamespace(window.smartNavElementsPDP, namespace).length;
}
export { getElementNamespace, getElementByNamespace, getInlineElementByNamespace, getBottombarElementByNamespace, getLauncherElementByNamespace, getSectionElementByNamespace, getPDPElementByNamespace, countInlineElementsByNamespace, countBottombarElementsByNamespace, countLauncherElementsByNamespace, countSectionElementsByNamespace, countPDPElementsByNamespace };
/* No side effect */